import { convertToDateTimeByTimezone, dateKeyFromDateTime, dateParser, dateTimeToTimeString } from './dateTimeUtils';
import { DEFAULT_LANG, DEFAULT_CURRENCY } from '../consts';
import { LocaleKeys } from '../locale-keys/LocaleKeys';
import { cleanAddress } from './cleanAddress';
import { getFormattedAdditionalFee, getFormattedPrice, getTotalPrice } from './deliveryOptionsUtils';
export const getGroupId = function (option, shouldMergeScheduledOptions) {
  var _option$deliveryAlloc, _option$logistics, _option$logistics2, _option$logistics3;
  if (shouldMergeScheduledOptions === void 0) {
    shouldMergeScheduledOptions = true;
  }
  const carrierId = option == null || (_option$deliveryAlloc = option.deliveryAllocations) == null || (_option$deliveryAlloc = _option$deliveryAlloc[0]) == null || (_option$deliveryAlloc = _option$deliveryAlloc.deliveryCarrier) == null ? void 0 : _option$deliveryAlloc.appId;
  if (!carrierId) {
    return option.code;
  }
  const hasDeliveryTimeSlot = !!((_option$logistics = option.logistics) != null && _option$logistics.deliveryTimeSlot);
  const hasDeliveryTime = !!((_option$logistics2 = option.logistics) != null && _option$logistics2.deliveryTime);
  const isPickup = !!((_option$logistics3 = option.logistics) != null && _option$logistics3.pickupDetails);
  const isScheduled = hasDeliveryTime && !isPickup;
  const shouldMergeByCarrierAndTitle = hasDeliveryTimeSlot || isScheduled && shouldMergeScheduledOptions;
  return shouldMergeByCarrierAndTitle ? `${carrierId}-${option.title}` : `${carrierId}-${option.code}`;
};
export const deliveryOptionsMapper = function (deliverySolutions, additionalData, shouldUseClientFormattingForPrices, shouldSeperateAdditionalFeeFromPrice, shouldMergeScheduledOptions, shouldSetSelectedDeliveryOptionData) {
  if (shouldMergeScheduledOptions === void 0) {
    shouldMergeScheduledOptions = true;
  }
  if (shouldSetSelectedDeliveryOptionData === void 0) {
    shouldSetSelectedDeliveryOptionData = false;
  }
  let hasPartialShippingOptions = false;
  let isSelectedOptionPartial = false;
  const selectedDeliveryOption = {};
  const groupedDeliveryOptions = {};
  const {
    selectedDeliveryCode,
    shouldShowOnlyPickup,
    timezone,
    language = DEFAULT_LANG,
    currency = DEFAULT_CURRENCY,
    t
  } = additionalData || {};
  const localeKeys = t ? LocaleKeys(t) : {};
  deliverySolutions == null || deliverySolutions.forEach(deliverySolution => {
    var _deliverySolution$log, _localeKeys$deliveryS, _deliverySolution$log8, _deliverySolution$log9;
    const isSelectedOption = deliverySolution.code === selectedDeliveryCode;
    const groupId = getGroupId(deliverySolution, shouldMergeScheduledOptions);
    if (!groupId) {
      return;
    }
    if (shouldShowOnlyPickup && !(deliverySolution != null && (_deliverySolution$log = deliverySolution.logistics) != null && _deliverySolution$log.pickupDetails)) {
      return;
    }
    if (deliverySolution.partial) {
      hasPartialShippingOptions = true;
    }
    const {
      baseCost,
      totalPrice
    } = getTotalPrice(deliverySolution);
    const price = shouldSeperateAdditionalFeeFromPrice ? baseCost : totalPrice;
    const formattedPrice = getFormattedPrice(shouldUseClientFormattingForPrices || false, shouldSeperateAdditionalFeeFromPrice || false, deliverySolution, language, currency, price) || '';
    const additionalCostFormattedPrice = getFormattedAdditionalFee(shouldUseClientFormattingForPrices || false, deliverySolution, language, currency);
    const additionalFeeKey = localeKeys == null || (_localeKeys$deliveryS = localeKeys.deliverySection) == null || (_localeKeys$deliveryS = _localeKeys$deliveryS.handlingFee) == null ? void 0 : _localeKeys$deliveryS.message({
      handlingFee: additionalCostFormattedPrice
    });
    if (!groupedDeliveryOptions[groupId]) {
      var _deliverySolution$log2, _deliverySolution$log3, _deliverySolution$log4, _deliverySolution$log5, _deliverySolution$log6, _deliverySolution$log7;
      groupedDeliveryOptions[groupId] = {
        groupId,
        title: deliverySolution.title || '',
        price,
        formattedPrice,
        partial: !!deliverySolution.partial,
        options: [],
        pickupDetails: (_deliverySolution$log2 = deliverySolution.logistics) == null ? void 0 : _deliverySolution$log2.pickupDetails,
        instructions: ((_deliverySolution$log3 = deliverySolution.logistics) == null ? void 0 : _deliverySolution$log3.instructions) || '',
        hasTimeSlots: false,
        subtitle: (deliverySolution != null && (_deliverySolution$log4 = deliverySolution.logistics) != null && _deliverySolution$log4.pickupDetails ? formatPickupAddress(localeKeys, deliverySolution, true) : deliverySolution == null || (_deliverySolution$log5 = deliverySolution.logistics) == null ? void 0 : _deliverySolution$log5.deliveryTime) || undefined,
        additionalFeeSubtitle: shouldSeperateAdditionalFeeFromPrice && additionalCostFormattedPrice ? additionalFeeKey : undefined,
        description: (deliverySolution != null && (_deliverySolution$log6 = deliverySolution.logistics) != null && _deliverySolution$log6.pickupDetails ? formatPickupAddress(localeKeys, deliverySolution, false) : deliverySolution == null || (_deliverySolution$log7 = deliverySolution.logistics) == null ? void 0 : _deliverySolution$log7.deliveryTime) || undefined
      };
    }
    if (isSelectedOption) {
      selectedDeliveryOption.groupId = groupId;
      selectedDeliveryOption.id = deliverySolution.code;
      groupedDeliveryOptions[groupId].price = price;
      groupedDeliveryOptions[groupId].formattedPrice = formattedPrice;
      if (shouldSetSelectedDeliveryOptionData) {
        selectedDeliveryOption.deliverySolution = deliverySolution;
      }
      if (deliverySolution.partial) {
        isSelectedOptionPartial = true;
      }
    }
    const option = {
      id: deliverySolution.code,
      deliveryTime: (deliverySolution == null || (_deliverySolution$log8 = deliverySolution.logistics) == null ? void 0 : _deliverySolution$log8.deliveryTime) || ''
    };
    if (deliverySolution != null && (_deliverySolution$log9 = deliverySolution.logistics) != null && _deliverySolution$log9.deliveryTimeSlot) {
      var _deliverySolution$log10, _deliverySolution$log11;
      const from = dateParser(deliverySolution == null || (_deliverySolution$log10 = deliverySolution.logistics) == null ? void 0 : _deliverySolution$log10.deliveryTimeSlot.from).getTime();
      const to = dateParser(deliverySolution == null || (_deliverySolution$log11 = deliverySolution.logistics) == null ? void 0 : _deliverySolution$log11.deliveryTimeSlot.to).getTime();
      if (from && to) {
        var _deliverySolution$log12;
        groupedDeliveryOptions[groupId].hasTimeSlots = true;
        const effectiveTimezone = (deliverySolution == null || (_deliverySolution$log12 = deliverySolution.logistics) == null || (_deliverySolution$log12 = _deliverySolution$log12.deliveryTimeSlot) == null ? void 0 : _deliverySolution$log12.timeZone) || timezone;
        const dateTime = convertToDateTimeByTimezone(from, effectiveTimezone);
        const dateKey = dateKeyFromDateTime(dateTime);
        const formattedDate = dateTime.toLocaleString({
          weekday: 'short',
          month: 'short',
          day: '2-digit'
        });
        let timeString = '';
        let timeSlotDeliveryTime = '';
        if (to !== from) {
          const endTimeString = convertToDateTimeByTimezone(to, effectiveTimezone);
          timeString = `${dateTimeToTimeString(dateTime)} - ${dateTimeToTimeString(endTimeString)}`;
        } else {
          timeString = dateTimeToTimeString(dateTime);
        }
        timeSlotDeliveryTime = `${formattedDate} | ${timeString}`;
        option.deliveryTime = dateTime.toLocaleString({
          weekday: 'short',
          month: 'short',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit'
        });
        option.dateKey = dateKey;
        option.timeString = timeString;
        option.timeSlotDeliveryTime = timeSlotDeliveryTime;
      }
    }
    groupedDeliveryOptions[groupId].options.push(option);
  });
  const violations = isSelectedOptionPartial ? [localeKeys.deliverySection.checkoutValidation.checkoutLevel()] : [];
  return {
    groupedDeliveryOptions,
    selectedDeliveryOption,
    hasPartialShippingOptions,
    violations
  };
};
export const sortDeliveryOptionsByPrice = deliveryOptions => {
  return deliveryOptions.sort((a, b) => {
    const aPrice = (a == null ? void 0 : a.price) || 0;
    const bPrice = (b == null ? void 0 : b.price) || 0;
    return aPrice - bPrice;
  });
};
export const splitDeliveryOptionsToPickupAndDelivery = deliveryOptions => {
  return deliveryOptions.reduce((acc, deliveryOption) => {
    if (deliveryOption.pickupDetails) {
      acc.pickupMethods.push(deliveryOption);
    } else {
      if (deliveryOption.hasTimeSlots || deliveryOption.options.length > 1) {
        deliveryOption.subtitle = undefined;
      }
      acc.deliveryMethods.push(deliveryOption);
    }
    return acc;
  }, {
    pickupMethods: [],
    deliveryMethods: []
  });
};
const formatPickupAddress = (localeKeys, deliverySolution, isWithZipCode) => {
  var _deliverySolution$log13, _localeKeys$deliveryS2, _localeKeys$deliveryS3;
  const address = deliverySolution == null || (_deliverySolution$log13 = deliverySolution.logistics) == null || (_deliverySolution$log13 = _deliverySolution$log13.pickupDetails) == null ? void 0 : _deliverySolution$log13.address;
  if (address === undefined || !localeKeys || !address.countryFullname) {
    return undefined;
  }
  const subdivision = address.subdivisionFullname;
  const keyData = {
    isWithSubdivision: !!subdivision,
    addressLine: address.addressLine,
    city: address.city,
    subdivision,
    zipCode: isWithZipCode ? address.postalCode : undefined,
    country: address.countryFullname
  };
  return cleanAddress(isWithZipCode ? localeKeys == null || (_localeKeys$deliveryS2 = localeKeys.deliverySection) == null || (_localeKeys$deliveryS2 = _localeKeys$deliveryS2.pickupAddress) == null ? void 0 : _localeKeys$deliveryS2.label.$value(keyData) : localeKeys == null || (_localeKeys$deliveryS3 = localeKeys.deliverySection) == null || (_localeKeys$deliveryS3 = _localeKeys$deliveryS3.pickupAddress) == null || (_localeKeys$deliveryS3 = _localeKeys$deliveryS3.label) == null ? void 0 : _localeKeys$deliveryS3.withoutZipCode(keyData));
};
//# sourceMappingURL=deliveryOptionsMappers.js.map